// Wait 1 milisec before proceeding
window.vueRender = function(toDo)
{ 
  setTimeout(function(){  toDo(); }, 1); 
}

// Finds the right index by key and value
window.findIndex = function(array, attr, value) {
    for(var i = 0; i < array.length; i++) {
        if(array[i].hasOwnProperty(attr) && array[i][attr] === value) {
            return i;
        }
    }
    return -1;
};

window.replaceAll = function(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}


// WEBPACK FOOTER //
// ./client/globalFunctions.js